const DEFER_KEY = 'defer_change_password'

export function isChangePasswordDeferred(): boolean {
  try {
    return sessionStorage.getItem(DEFER_KEY) === '1'
  } catch {
    return false
  }
}

export function deferChangePasswordSession(): void {
  try {
    sessionStorage.setItem(DEFER_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function clearChangePasswordDefer(): void {
  try {
    sessionStorage.removeItem(DEFER_KEY)
  } catch {
    /* ignore */
  }
}

export function effectiveMustChangePassword(serverFlag: boolean): boolean {
  return serverFlag && !isChangePasswordDeferred()
}
